<template>
    <div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Case Study
                </div>
            </div>
            <div class="main">
                <div class="content">

                    <div class="form-sections">

                        <div class="form-section">
                            <div class="sub-title">
                                Customer Details
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Company Name</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_company_name') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Main Contact Name</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_main_contact_name') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Address</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_address') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Website Address</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_website_address') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Telephone No.</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_telephone_number') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Mobile No.</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_mobile_number') }}</div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Email</label>
                                    <div class="p-3">{{ getCaseStudyDetail('company_details_email') }}</div>
                                </div>
                            </div>
                        </div>


                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Project Outline
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>What is the name of the project?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_name_of_project') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Where is it?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_where_is_it') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Who is the customer?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_who_is_customer') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>What is being delivered?</label>
                                    <template v-if="getCaseStudyDetail('project_outline_what_is_being_delivered') !== 'Other'">
                                        <div class="p-3">{{ getCaseStudyDetail('project_outline_what_is_being_delivered') }}</div>
                                    </template>
                                    <template v-if="getCaseStudyDetail('project_outline_what_is_being_delivered') === 'Other'">
                                        <div class="p-3">{{ getCaseStudyDetail('project_outline_what_is_being_delivered_other') }}</div>
                                    </template>
                                </div>

                                <div class="form-group">
                                    <label>How many windows and doors are being installed?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_how_many_windows_and_doors') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>What is the time frame?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_time_frame') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>When does (did) it start?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_start_date') }}</div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>When does (did) it end?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('project_outline_end_date') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section mt-10 _what-products">

                            <div class="sub-title">
                                What product(s) is the project using?
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Windows</label>
                                    <div class="p-3">{{ getCaseStudyDetail('products_windows') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Doors</label>
                                    <div class="p-3">{{ getCaseStudyDetail('products_doors') }}</div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Other</label>
                                    <div class="p-3">{{ getCaseStudyDetail('products_other') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Questionnaire
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Have their been any particular challenges in project delivery and how were they overcome?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('questionnaire_challenges_that_were_overcome') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>What benefits has the project delivered to the customer?</label>
                                    <div class="p-3">{{ getCaseStudyDetail('questionnaire_benefits_to_customer') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Images</label>
                                    <div class="p-3">
                                        <div class="attachments">
                                            <div v-for="(attachment, index) in case_study.case_study_attachments" class="attachment">
                                                <a @click.prevent="attachment_modal_open = true, selected_image_index = index" :style="attachmentUrl(attachment)" class="image">
                                                    <span class="view-btn"><i class="fal fa-search"></i></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Consent
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Are you happy for us to promote on our digital commercial platforms:</label>
                                    <div class="p-3">{{ getCaseStudyDetail('consent_digital_platforms') }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Are you happy for us to promote in the fenestration press:</label>
                                    <div class="p-3">{{ getCaseStudyDetail('consent_fenestration_press') }}</div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Are you happy for us to promote across social media:</label>
                                    <div class="p-3">{{ getCaseStudyDetail('consent_social_media') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="attachments-modal-window" :class="{'open': attachment_modal_open}" @click="attachment_modal_open = false, selected_image_index = 0" v-if="attachment_modal_open">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="attachment_modal_open = false, selected_image_index = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-content">
                    <div class="selected-image">
                        <img :src="`${$aws_bucket_url}${case_study.case_study_attachments[selected_image_index].file_url}`">
                        <a class="download-button" @click.prevent="downloadAttachment(case_study.case_study_attachments[selected_image_index].id)">
                            <i class="fal fa-download"></i>
                        </a>
                    </div>
                    <div class="attachments">
                        <div v-for="(attachment,  index) in case_study.case_study_attachments" class="attachment">
                            <a @click.prevent="selected_image_index = index" :style="attachmentUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        'case_study': {
            required: true,
        },
    },
    data() {
        return {
            attachment_modal_open: false,
            selected_image_index: 0,
        }
    },
    methods: {
        getCaseStudyDetail(detail_key) {
            const detail = this.case_study.case_study_details.find(detail => {
                return detail.key === detail_key
            });

            if(Array.isArray(detail.value)) {
                return detail.value.join(', ');
            }

            if(detail) {
                return detail.value;
            }

            return '--';
        },
        attachmentUrl(attachment) {
            return {'backgroundImage' : `url('${this.$aws_bucket_url}${attachment.file_url}')`};
        },
        downloadAttachment(attachment_id) {
            axios.post( '/commercial/case-studies/download-attachment', {
                attachment_id: attachment_id,
            }).then((response) => {
                window.location.href = response.data;
            });
        },
    },
};
</script>
